import { render, staticRenderFns } from "./PlantillaList.vue?vue&type=template&id=712ff510&scoped=true"
import script from "./PlantillaList.vue?vue&type=script&lang=js"
export * from "./PlantillaList.vue?vue&type=script&lang=js"
import style0 from "./PlantillaList.vue?vue&type=style&index=0&id=712ff510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ff510",
  null
  
)

export default component.exports